import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PrimeNgImportsModule} from '../../prime-ng-imports';

/**
 * FFAccordion component
 */
@Component({
    selector: 'app-ff-accordion',
    templateUrl: './ff-accordion.component.html',
    styleUrl: './ff-accordion.component.scss',
    imports: [PrimeNgImportsModule]
})
export class FFAccordionComponent implements OnInit {
    protected _borders: ('left' | 'right')[] = ['left', 'right'];
    protected _styleClasses: string[] = [];

    // ===============================================================
    // ===============================================================

    @Input()
    public value: string | number = 0;
    @Input()
    public set borders(values: ('left' | 'right')[]) {
        this._borders = values;
        this.updateStyle();
    }
    @Output()
    public valueChange = new EventEmitter<string | number>();

    // ===============================================================
    // ===============================================================

    /**
     * On init
     */
    public ngOnInit(): void {
        this.updateStyle();
    }

    // ===============================================================
    // ===============================================================

    /**
     * Change active value
     * @param newValue New active value
     */
    public changeActiveValue(newValue: string | number) {
        this.value = newValue;
        this.valueChange.emit(newValue);
    }

    // ===============================================================
    // ===============================================================

    /**
     * Compute component style
     */
    private updateStyle() {
        this._styleClasses = [''];

        if (this._borders.indexOf('left') !== -1) this._styleClasses.push('border-left');

        if (this._borders.indexOf('right') !== -1) this._styleClasses.push('border-right');
    }
}
